import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: Paginacao(['dataCriacao'], 25, 'DESC'),
	filtro: {
		nome: {
			default: null,
			label: 'Título ou tipo',
			value: null,
		},
	},
	filtroBuscaNaoPaginada: {
		nome: String(),
		idTipoDocumento: null,
	},
	modeloEdicao: {
		idModeloDocumento: null,
		nome: null,
		idTipoDocumento: null,
		situacao: null,
	},
}
